import gql from 'graphql-tag';

export const MULTI_CREATIVE_DELETE_MUTATION = gql`
  mutation MultiDeleteCreatives($creativeIds: [ID!]!) {
    multiDeleteCreatives(creativeIds: $creativeIds) {
      creatives {
        id
      }
      errors
    }
  }
`;
